import { useEffect } from 'react';
import { useToast, TradingToast } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import { parseBackendReason } from '@/utils/error.utils';

import type { ProcessedBackendError } from '@/interfaces';
import type { ConsumptionChartResponse } from '@/interfaces/consumer.interfaces';

export const useConsumerErrorHandling = (
  tableError: Error | null,
  chartError: Error | null,
  chartData: ConsumptionChartResponse | undefined
) => {
  const { addToast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (tableError) {
      addToast(
        <TradingToast
          type="error"
          title="Error"
          message={parseBackendReason(tableError as Error | ProcessedBackendError)}
        />
      );
    }
  }, [tableError, addToast]);

  useEffect(() => {
    if (chartError) {
      addToast(
        <TradingToast
          type="error"
          title="Error"
          message={parseBackendReason(chartError as Error | ProcessedBackendError)}
        />
      );
    }
  }, [chartError, addToast]);

  useEffect(() => {
    if (chartData?.consumptions.length === 0) {
      addToast(
        <TradingToast
          type="warning"
          title={t('services.getConsumptions.warning')}
          message={t('services.getConsumptions.message')}
        />
      );
    }
  }, [chartData, addToast, t]);
};
